// Helper function to create observer management utilities

export const createObserverManager = () => {
  const observers = new Set();

  return {
    add: (observer) => {
      if (!observers.has(observer)) observers.add(observer);
    },
    remove: (observer) => {
      observers.delete(observer);
    },
    clear: () => {
      observers.clear();
    },
    notify: (...responseData) => {
      observers.forEach((observer) => observer(...responseData));
    },
  };
};

// Dynamic helper function to get observers for a specific action (e.g., 'add', 'remove')
export const getObservers = (registry, action) => {
  const result = {};
  Object.keys(registry).forEach((key) => {
    result[key] = registry[key][action];
  });
  return result;
};
